import React from 'react';
import { TextV2 } from '@withjoy/joykit';
import { dottedUnderlineStyles } from './DottedButton.styles';

type DottedTextButtonProps = Readonly<{
  onClick?: () => void;
  isDisabled?: boolean;
  typographyVariant?: React.ComponentProps<typeof TextV2>['typographyVariant'];
  children?: React.ReactNode;
}>;

export const DottedTextButton: React.FC<DottedTextButtonProps> = ({ onClick, isDisabled, typographyVariant = 'body2', children }) => (
  <TextV2
    as="button"
    type="button"
    onClick={onClick}
    disabled={isDisabled}
    display="inline"
    typographyVariant={typographyVariant}
    fontWeight={600}
    color="mono12"
    backgroundColor="transparent"
    border="none"
    padding={0}
    cursor={isDisabled ? 'default' : 'pointer'}
    css={dottedUnderlineStyles}
    _hover={isDisabled ? undefined : { color: 'buttonPrimaryHover' }}
    _focusVisible={{ color: 'buttonPrimaryHover', outline: '2px solid', outlineColor: 'newUIBrandPrimary', outlineOffset: '2px' }}
  >
    {children}
  </TextV2>
);
